<template>
<div class="area__contect">
<div class="container my-5 ">
  <h1>Bhima Riddhi Infotainment Pvt Ltd</h1>
  <div class="row mt-5">
    <div class="col-md-6 col-12">
      <div class="contact-widget-wrap contact-1">
        <div class="contact-box">
          <div class="contact-icon">
            <span>Our Address</span>
          </div>
        <div class="contact-box-content">
          <div class="contact-content">
            <p>446/5, E Ward, Kailash Tower, 3rd Floor, Station Road,
Shahupuri , Kolhapur- 416001</p>
          </div>
        </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-12">
 <div class="contact-widget-wrap contact-2">
        <div class="contact-box">
          <div class="contact-icon">
            <span>Call / Email Us</span>
          </div>
        <div class="contact-box-content">
          <div class="contact-content">
            <p>Email: bhimariddhicustomercare@gmail.com</p>
            <p>
                Mobile : 7387126704, 7755982688
                Phone: 0231-2656977</p>
          </div>
        </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
</template>

<script>
export default {
  data() {
    return {
      open: false
    }
  },
}
</script>
<style>
.area__contect {
  background-color: #fafaff;
  padding: 60px 0px;
}
.area__contect h1 {
  padding-bottom:100px;
  text-align: center;
}
.contact-widget-wrap .contact-box {
    padding: 0px 40px 40px 40px;
    background-color: #ffffff;
    text-align: center;
    border-radius: 5px 5px 5px 5px;
    transform: translateY(0);
    transition-duration: 0.3s;
}
.contact-widget-wrap.contact-1 .contact-box .contact-icon {
   width: 118px;
    line-height: 118px;
    color: #ffffff;
    background-color: #4285ff;
    text-align: center;
    float: none;
    margin: -50px 0px 25px 0px;
    padding: 0px 0px 0px 0px;
    border-radius: 100% 100% 100% 100%;
    -webkit-box-shadow: 0px 16px 32px 0px rgba(65,140,255,0.3);
    box-shadow: 0px 16px 32px 0px rgba(65,140,255,0.3);
    -webkit-transition-duration: 0.3s;
    transition-duration: 0.3s;
}
.contact-widget-wrap .contact-box .contact-icon {
    display: inline-block;
    position: relative;
    z-index: 1;
    overflow: hidden;
}
.contact-widget-wrap .contact-box .contact-icon span {
  font-size: 15px;
}
.contact-widget-wrap .contact-box .contact-icon::before {
  content: ' ';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    opacity: 1;
    -webkit-transition: 0.3s;
    -o-transition: 0.3s;
    transition: 0.3s;
}
.contact-widget-wrap.contact-2 .contact-box .contact-icon {
    background-color: #ff8542;
    box-shadow: 0px 16px 32px 0px rgba(255,133,66,0.3);
    width: 118px;
    line-height: 118px;
    color: #ffffff;
    text-align: center;
    float: none;
    margin: -50px 0px 25px 0px;
    padding: 0px 0px 0px 0px;
    border-radius: 100% 100% 100% 100%;
    -webkit-transition-duration: 0.3s;
    transition-duration: 0.3s;
}
</style>